import evvyaiLogo from "@/components/chat/evvyai-logo-beta.svg";
import { cn } from "@/utils/cn";

interface Props {
  isExpanded: boolean;
  onToggleExpand: () => void;
  onClose: () => void;
  mobileHistoryOpen?: boolean;
  onToggleMobileHistory?: () => void;
}

export default function ChatHeader({
  isExpanded,
  onToggleExpand,
  onClose,
  mobileHistoryOpen,
  onToggleMobileHistory,
}: Props) {
  return (
    <div
      className={cn(
        "flex items-center justify-between border-b",
        "shrink-0",
        "border-[var(--chat-grey-100)]",
        isExpanded
          ? "px-[40px] py-[24px]"
          : "px-[16px] py-[16px] sm:px-[var(--chat-space-06)] sm:py-[24px]"
      )}
    >
      {/* Mobile: history hamburger / Desktop: expand/collapse toggle */}
      {/* Mobile history toggle */}
      <button
        onClick={onToggleMobileHistory}
        className="sm:hidden flex items-center justify-center w-[var(--chat-icon-lg)] h-[var(--chat-icon-lg)] text-[var(--chat-black)] hover:opacity-70 transition-opacity"
        aria-label={mobileHistoryOpen ? "Close history" : "Open history"}
      >
        {mobileHistoryOpen ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 5.38103L10.7019 10.8155L9.55592 11.991L10.7019 13.1665L16 18.5829L14.4132 20.2286L6.4 11.991L14.4132 3.77148L16 5.38103Z"
              fill="currentColor"
            />
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_1324_9149)">
              <path
                d="M3.75 12H13.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.75 6C10.1937 6 13.8063 6 20.25 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M3.75 18H18.25"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1324_9149">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        )}
      </button>
      {/* Desktop expand/collapse toggle */}
      <button
        onClick={onToggleExpand}
        className="hidden sm:flex items-center justify-center w-[var(--chat-icon-lg)] h-[var(--chat-icon-lg)] text-[var(--chat-black)] hover:opacity-70 transition-opacity"
        aria-label={isExpanded ? "Collapse chat" : "Expand chat"}
      >
        {isExpanded ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="4 14 10 14 10 20" />
            <polyline points="20 10 14 10 14 4" />
            <line x1="14" y1="10" x2="21" y2="3" />
            <line x1="3" y1="21" x2="10" y2="14" />
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 3 21 3 21 9" />
            <polyline points="9 21 3 21 3 15" />
            <line x1="21" y1="3" x2="14" y2="10" />
            <line x1="3" y1="21" x2="10" y2="14" />
          </svg>
        )}
      </button>

      {/* EvvyAI logo */}
      <img src={evvyaiLogo} alt="EvvyAI" className="h-[24px]" />

      {/* Close button */}
      <button
        onClick={onClose}
        className="flex items-center justify-center w-[var(--chat-icon-lg)] h-[var(--chat-icon-lg)] text-[var(--chat-black)] hover:opacity-70 transition-opacity"
        aria-label="Close chat"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
